export enum EDroneDockingState {
  DS_UNDOCKED,
  DS_DOCKING,
  DS_DOCKED,
  DS_TAKEOFF,
}
